import {deleteDB, openDB} from "idb";
import {
    absenceTable,
    costUnitTable,
    databaseName,
    dataToServerTable,
    flowChartTable,
    lastBookingTable,
    machineTable,
    orderItemTable,
    orderTable,
    personTable,
    projectTable,
    systemConfigurationTable,
    systemLogTable,
    systemTable,
    workCombinationTable,
    workplaceTable,
    workprocessTable
} from "../../config.json";

export const isDatabaseActive = () => {
    if ("indexedDB" in window) {
        return true;
    } else {
        return false;
    }
};

export const openDatabase = async () => {
    const db = await openDB(databaseName, 5, {
        upgrade(db, oldVersion, newVersion, transaction) {
            console.log(
                "database=",
                databaseName,
                ": oldVersion=",
                oldVersion,
                ", newVersion=",
                newVersion
            );

            if (oldVersion <= 0) {
                db.createObjectStore(dataToServerTable, {
                    keyPath: "id",
                    autoIncrement: true
                });

                const systemConfigurationStore = db.createObjectStore(
                    systemConfigurationTable,
                    {
                        keyPath: "id",
                        autoIncrement: true
                    }
                );
                systemConfigurationStore.createIndex("name", "name");
            }

            if (oldVersion <= 1) {
                const systemStore = db.createObjectStore(systemTable, {
                    // Benutzer, Passwort
                    keyPath: "id",
                    autoIncrement: true
                });
                systemStore.createIndex("name", "name");

                const systemLogStore = db.createObjectStore(systemLogTable, {
                    // letzte Aktualisierung
                    keyPath: "id",
                    autoIncrement: true
                });
                systemLogStore.createIndex("name", "name");

                db.createObjectStore(flowChartTable, {
                    keyPath: "id",
                    autoIncrement: true
                });

                const personStore = db.createObjectStore(personTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                personStore.createIndex("number", "number");

                const absenceStore = db.createObjectStore(absenceTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                absenceStore.createIndex("number", "number");

                const projectStore = db.createObjectStore(projectTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                projectStore.createIndex("number", "number");

                const orderStore = db.createObjectStore(orderTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                orderStore.createIndex("number", "number");

                const orderItemStore = db.createObjectStore(orderItemTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                orderItemStore.createIndex("number", "number");

                const costUnitStore = db.createObjectStore(costUnitTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                costUnitStore.createIndex("number", "number");

                const machineStore = db.createObjectStore(machineTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                machineStore.createIndex("number", "number");

                const workplaceStore = db.createObjectStore(workplaceTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                workplaceStore.createIndex("number", "number");

                const workprocessStore = db.createObjectStore(workprocessTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                workprocessStore.createIndex("number", "number");
            }

            if (oldVersion <= 2) {
                const lastBookingStore = db.createObjectStore(lastBookingTable, {
                    keyPath: "id",
                    autoIncrement: true
                });
                lastBookingStore.createIndex("name", "name");
            }

            if (oldVersion <= 3) {
                const workCombinationStore = db.createObjectStore(workCombinationTable, {
                    keyPath: "id",
                    autoIncrement: true
                });

                workCombinationStore.createIndex("dbId", "dbId");

                workCombinationStore.createIndex("projectNumber", "project.number", {multiEntry: true})
                workCombinationStore.createIndex("orderNumber", "order.number", {multiEntry: true})
                workCombinationStore.createIndex("orderItemNumber", "orderItem.number", {multiEntry: true})
                workCombinationStore.createIndex("costUnitNumber", "costUnit.number", {multiEntry: true})
                workCombinationStore.createIndex("machineNumber", "machine.number", {multiEntry: true})
                workCombinationStore.createIndex("workplaceNumber", "workplace.number", {multiEntry: true})
                workCombinationStore.createIndex("workprocessNumber", "workprocess.number", {multiEntry: true})

            }

            if (oldVersion <= 4) {
                transaction.objectStore(personTable).createIndex("dbId", "dbId");
                transaction.objectStore(absenceTable).createIndex("dbId", "dbId");
                transaction.objectStore(projectTable).createIndex("dbId", "dbId");
                transaction.objectStore(orderTable).createIndex("dbId", "dbId");
                transaction.objectStore(orderItemTable).createIndex("dbId", "dbId");
                transaction.objectStore(costUnitTable).createIndex("dbId", "dbId");
                transaction.objectStore(machineTable).createIndex("dbId", "dbId");
                transaction.objectStore(workplaceTable).createIndex("dbId", "dbId");
                transaction.objectStore(workprocessTable).createIndex("dbId", "dbId");
            }

        }
    });
    db.onerror = function (event) {
        console.log("open database -> error: event=", event);
    };
    db.onsuccess = function (event) {
        // TODO: wird nie aufgerufen
        console.log("open database -> OK: event=", event);
    };
    return db;
};

export const deleteDatabase = async db => {
    if (!db) return;
    //const closed =
    await db.close(); // ??
    await deleteDB(databaseName, {
        blocked() {
            console.log(
                "localBookingStorage.deleteDatabase() -> blocked",
                "databaseName =",
                databaseName,
                "db =",
                db
            );
        }
    });
};
